import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openPopupAction, pauseGame } from "../../redux/actions/actions";
import * as actionTypes from "../../redux/types/types";
import "./Button.css";

const Button = ({ type, onClick }) => {
  const dispatch = useDispatch();
  const isGameStarted = useSelector((state) => state.game.isGameStarted);
  const isGameOver = useSelector((state) => state.game.gameOver);
  const buttonMessage = useSelector((state) => state.game.togglePauseMessage);

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      switch (type) {
        case "main-menu":
          handleMainMenuClick();
          break;
        case "start":
          handlePlayClick();
          break;
        case "instructions":
          handleInstructionsClick();
          break;
        case "replay":
          handleReplayClick();
          break;
        case "pause":
          handlePauseClick();
          break;
        default:
          break;
      }
    }
  };

  const handleMainMenuClick = () => {
    dispatch({ type: actionTypes.BACK_TO_MAIN_MENU });
  };

  const handleInstructionsClick = () => {
    dispatch(openPopupAction());
  };

  const handlePlayClick = () => {
    if (!isGameStarted) {
      dispatch({ type: actionTypes.START_GAME });
    }
  };

  const handleReplayClick = () => {
    dispatch({ type: actionTypes.RESET_GAME });

    setTimeout(() => {
      dispatch({ type: actionTypes.START_GAME });
    }, 0);
  };

  const handlePauseClick = () => {
    dispatch(pauseGame());
  };

  return (
    <button
      className={`button ${type}-button`}
      onClick={handleClick}
      data-testid={`${type}-button`}
    >
      {isGameStarted && type === "main-menu"
        ? "Main Menu"
        : type === "start" && !isGameStarted
        ? "Start Game"
        : type === "pause" && isGameStarted
        ? `${buttonMessage.message}`
        : type === "instructions" && !isGameStarted
        ? "How To Play"
        : type === "replay" && isGameOver
        ? "Replay"
        : ""}
    </button>
  );
};

export default Button;
